const style = (theme) => {
  const iconButtonHeight = 35
  const transition = `all 1s ${theme.easings['power4.out']}`

  const output = {
    root: {
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: theme.zindex.header,
      pointerEvents: 'none',
      '& $menuButton': {
        transition,
        color: theme.colors[1],
      },
      '& $wrapper': {
        transition: `all 0.3s ${theme.easings['power4.out']}`,
        background: 'transparent',
      },
      '& $icon': {
        transition,
        background: 'transparent',
        '& svg': {
          transition,
          fill: theme.colors[1],
        },
      },
    },
    whiteBackground: {
      '& $menuButton': {
        color: theme.colors[2],
      },
      '& $wrapper': {
        background: theme.colors[1],
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.16)',
      },
      '& $icon': {
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.16)',
        '& svg': {
          transition,
          fill: theme.colors[2],
        },
      },
      '& $logo': {
        '& svg': {
          fill: (props) => (props.isIE11 ? theme.colors[2] : theme.colors[1]),
        },
      },
    },
    isInTransition: {
      '& $logo': {
        pointerEvents: 'none',
      },
      '& $nav': {
        pointerEvents: 'none',
      },
    },
    container: {
      padding: '0 4.5vw',
      margin: '0 auto',
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.header.top,
      padding: '0 2.5vw',
      borderRadius: 27,
      height: theme.header.height,
      transition,
    },
    logo: {
      display: 'inline-block',
      pointerEvents: 'all',
      transition,
      mixBlendMode: 'difference',
      '& svg': {
        transition,
        fill: theme.colors[1],
      },
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      pointerEvents: 'all',
      height: '100%',
      '& > *:not(:last-child)': {
        marginRight: '5.55vw',
      },
    },
    menuButton: {
      cursor: 'pointer',
      textTransform: 'uppercase',
      letterSpacing: 1,
      fontSize: 14,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      overflow: 'visible',
    },
    mainMenuButton: {
      position: 'relative',
    },
    menuButtonBackMobile: {
      position: 'absolute',
      right: '8vw',
      top: 65,
      margin: '0 !important',
    },
    closeLabel: {
      position: 'absolute',
      pointerEvents: 'none',
      background: theme.colors[1],
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      transition: `all 0.2s ${theme.easings['power4.out']}`,
    },
    menuButtonShop: {
      marginRight: '10px !important',
    },
    menuButtonIcon: {
      display: 'flex',
      '& $icon': {
        marginLeft: 10,
      },
    },
    icon: {
      borderRadius: 10,
      width: iconButtonHeight,
      height: iconButtonHeight,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        width: 18,
        height: 18,
      },
    },
    hide: {
      opacity: 0,
      pointerEvents: 'none',
    },
  }

  output[theme.mediaInverse.md] = {
    wrapper: {
      marginTop: 50,
      padding: '0 5vw',
    },
    nav: {
      '& > *:not(:last-child)': {
        marginRight: 30,
      },
    },
    container: {
      padding: '0 2vw',
      margin: '0 auto',
    },
  }

  output[theme.mediaInverse.sm] = {
    wrapper: {
      marginTop: 0,
      borderRadius: 0,
      padding: '10px 8vw',
    },
    container: {
      padding: 0,
    },
  }

  return output
}

export default style
